import React from 'react'
import { Image } from 'react-bootstrap'

const stopPropagation = e => {
  e.stopPropagation(true)
}

class ImagePreview extends React.PureComponent {
  static defaultProps = {
    src: '',
    style: {},
    imgStyle: {},
    onClick: stopPropagation,
  }

  onError = ({ currentTarget }) => {
    currentTarget.onerror = null
    currentTarget.src = '/no_img.jpg'
  }

  render() {
    let { style, imgStyle, src } = this.props
    return (
      <div style={{ width: '3.5rem', height: '3.5rem', ...style }}>
        <Image
          style={{
            objectFit: 'cover',
            display: 'block',
            width: '100%',
            height: '100%',
            ...imgStyle,
          }}
          lazy="true"
          alt=""
          src={src !== '' ? src : '/no_img.jpg'}
          role={src !== '' ? 'button' : ''}
          onClick={src !== '' ? this.props.onClick : stopPropagation}
          onError={this.onError}
          thumbnail
        />
      </div>
    )
  }
}
export default ImagePreview
